<div class="right-side p-5">
  <h2>Invoice Dashboard</h2>
  <div class="section">

    <div class="row">
      <div class="text-end mb-2">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
        <!--<button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>-->
      </div>

      <div class="col-lg-7 col-sm-12">
        <form [formGroup]="form">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="searchControl" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>

        </form>
      </div>
    </div>
    <!--<div class="col-lg-3 col-sm-6 text-end">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput (input)="onSearchChange($event)" />
      </mat-form-field>
    </div>-->
    <!--<div class="table-responsive">
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th class="text-center">Name of Event</th>
            <th class="text-center">Intervention</th>
            <th class="text-center">Component</th>
            <th class="text-center">Event Status</th>
            <th class="text-center">Count of MSME attended the event (Verified/Unverified)</th>
            <th class="text-center">Invoice Status</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of EventList ; let i = index ">
            <td>{{ i+1 }}</td>
            <td class="text-center">{{ el.eventName }}</td>
            <td class="text-center">{{ el.interventionName }}</td>
            <td class="text-center">{{ el.interestName }}</td>
            <td class="text-center">{{ el.eventStatus }}</td>
            <td class="text-center">{{ el.noOfMSMEAttended }}</td>
            <td class="text-center">{{ el.invoiceStatus }}</td>
            <td class="text-center">
              <button class="btn btn-primary btn-sm me-2"> <i class="bi bi-eye"></i>View</button>
              <button class="btn btn-primary btn-sm me-2" (click)="invoiceCalculation(el.eventId)"> <i class="bi bi-eye"></i>Show Calculation</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->
    <!--<mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [disabled]="disabled"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>-->


    <div #eventPopup class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="InvoiceStatus" matSort matSortDirection="asc" matSortDisableClear>
        <ng-container matColumnDef="Sr.No">
          <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
          <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
        </ng-container>
        <ng-container matColumnDef="InvoiceID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Id</th>
          <!--<td mat-cell *matCellDef="let el" class="text-primary no-underline" style="cursor: pointer;" (click)="invoiceCalculation(el.eventId)"> {{el.eventName}} </td>-->
          <td mat-cell *matCellDef="let el"> {{el.invoiceID}} </td>
        </ng-container>
        <ng-container matColumnDef="EventId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Id</th>
          <!--<td mat-cell *matCellDef="let el" class="text-primary no-underline" style="cursor: pointer;" (click)="invoiceCalculation(el.eventId)"> {{el.eventName}} </td>-->
          <td mat-cell *matCellDef="let el"> {{el.eventId}} </td>
        </ng-container>
        <ng-container matColumnDef="NameofEvent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name of Event</th>
          <!--<td mat-cell *matCellDef="let el" class="text-primary no-underline" style="cursor: pointer;" (click)="invoiceCalculation(el.eventId)"> {{el.eventName}} </td>-->
          <td mat-cell *matCellDef="let el"> {{el.eventName}} </td>
        </ng-container>
        <ng-container matColumnDef="Intervention">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention</th>
          <td mat-cell *matCellDef="let el"> {{el.interventionName}} </td>
        </ng-container>
        <ng-container matColumnDef="Component">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Component</th>
          <td mat-cell *matCellDef="let el"> {{el.interestName}} </td>
        </ng-container>
        <ng-container matColumnDef="EventStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Status</th>
          <td mat-cell *matCellDef="let el"> {{el.eventStatus}} </td>
        </ng-container>
        <ng-container matColumnDef="NoOfMSMEAttended">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total count of Verified MSME Attended</th>
          <td mat-cell *matCellDef="let el"> {{el.noOfMSMEAttended}} </td>
        </ng-container>
        <!--<ng-container matColumnDef="ViewAttendedMSME">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>View Attended MSME List</th>
  <td mat-cell *matCellDef="let el">
    <button class="btn btn-primary btn-sm me-2" type="button" (click)="ViewAttendedMSME()" id="btnReset">
      View
    </button>
  </td>
  </ng-container>-->
        <ng-container matColumnDef="InvoiceStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Status</th>
          <td mat-cell *matCellDef="let el"> {{el.invoiceStatus}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let el">
            <!--<button class="btn btn-primary btn-sm me-2"> <i class="bi bi-eye"></i>View</button>-->
            <button class="btn btn-primary btn-sm me-2" (click)="invoiceCalculation(el.eventId, '0', el.invoiceStatus === null ? 'EDIT' : 'VIEW')">
              <i class="bi bi-eye"></i>
              {{ el.invoiceStatus === null ? 'Show Calculation' : 'View' }}
            </button>
            <!--Commented code on 21-07-2025-->
            <button class="btn btn-info btn-sm mt-2" (click)="viewInvoiceDetails(invoicedoc,el.eventId)"><i class="bi bi-eye"></i> Audit Trail</button>
            <!--Commented code on 21-07-2025-->
            <button *ngIf="el.rejectedStatus === 1"
                    class="btn btn-danger btn-sm me-2 mt-2"
                    (click)="reSubmissionCalculation(el.eventId, el.rejectedStatus)">
              <i class="bi bi-x-circle"></i>
              Resubmit
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        Row shown when there is no matching data.
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter</td>

        </tr>
      </table>

    </div>
    <mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>


    <!--Invoice List Grid-->
    <ng-template #invoicedoc #filePreviewTemplate>
      <h1 mat-dialog-title>Invoice List</h1>
      <div mat-dialog-content>
        <div class="row mb-1">
          <div class="col-md-12">
            <div class="table-responsive">
              <table mat-table [dataSource]="invoiceDataSource" matSort class="table table-striped table-bordered table-hover"
                     matTableResponsive matSortActive="eventId" matSortDirection="desc" matSortDisableClear>
                <ng-container matColumnDef="Sr.No">
                  <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                  <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                </ng-container>
                <ng-container matColumnDef="eventId">
                  <th mat-header-cell *matHeaderCellDef>Event Id</th>
                  <td mat-cell *matCellDef="let el"> {{el.eventId}} </td>
                </ng-container>
                <ng-container matColumnDef="invoiceId">
                  <th mat-header-cell *matHeaderCellDef>Invoice Id</th>
                  <td mat-cell *matCellDef="let el"> {{el.invoiceId}} </td>
                </ng-container>
                <ng-container matColumnDef="dateofSubmission">
                  <th mat-header-cell *matHeaderCellDef>Date of Submission</th>
                  <td mat-cell *matCellDef="let el">   {{ el.dateofSubmission | date:'dd/MM/yyyy' }} </td>
                </ng-container>
                <ng-container matColumnDef="dateofActionTaken">
                  <th mat-header-cell *matHeaderCellDef>Date of Action Taken</th>
                  <td mat-cell *matCellDef="let el"> {{el.dateofActionTaken | date:'dd/MM/yyyy' }} </td>
                </ng-container>
                <ng-container matColumnDef="finalTotal">
                  <th mat-header-cell *matHeaderCellDef>Final Total</th>
                  <td mat-cell *matCellDef="let el"> {{el.finalTotal}} </td>
                </ng-container>
                <ng-container matColumnDef="Download">
                  <th mat-header-cell *matHeaderCellDef>Document</th>
                  <td mat-cell *matCellDef="let el">
                    <a class="text-decoration-none btn btn-warning btn-sm mt-1" *ngIf="el.invoiceFilePath"
                       (click)="onDownload(el.invoiceFilePath, el.invoiceFileName); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
                      <i class="bi bi-download"></i> Download
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let el">
                    <!--<button class="btn btn-primary btn-sm me-2" (click)="invoiceCalculation(el.eventId, '0')">
    <i class="bi bi-eye"></i>
    {{ el.invoiceStatus === null ? 'Show Calculation' : 'View' }}
  </button>-->

                    <button class="btn btn-primary btn-sm me-2"
                            (click)="invoiceCalculation(el.eventId, '0', el.invoiceStatus === null ? 'EDIT' : 'VIEW')">
                      <i class="bi bi-eye"></i>
                      {{ el.invoiceStatus === null ? 'Show Calculation' : 'View' }}
                    </button>

                    <!--<button class="btn btn-primary btn-sm mt-1" *ngIf="el.invoiceFilePath"
          (click)="openFilePreviewDialog(filePreviewTemplate, el.invoiceFilePath, el.invoiceFileName)">
    <i class="bi bi-eye"></i> View File
  </button>-->
                  </td>
                </ng-container>
                <ng-container matColumnDef="invoiceAccepted">
                  <th mat-header-cell *matHeaderCellDef>Invoice Status</th>
                  <td mat-cell *matCellDef="let el">
                    <span [ngClass]="
        el.invoiceAccepted === true
          ? 'text-success'
          : el.invoiceAccepted === false
          ? 'text-danger'
          : 'text-info'
      ">
                      {{
        el.invoiceAccepted === true
          ? 'Accepted'
          : el.invoiceAccepted === false
          ? 'Rejected'
          : 'Pending'
                      }}
                    </span>
                  </td>
                </ng-container>

                <!--<ng-container matColumnDef="invoiceAccepted">
                  <th mat-header-cell *matHeaderCellDef>Invoice Accepted</th>
                  <td mat-cell *matCellDef="let el"> {{el.invoiceAccepted}} </td>
                </ng-container>-->
                <!--<ng-container matColumnDef="invoiceAccepted">
                  <th mat-header-cell *matHeaderCellDef>Invoice Status</th>
                  <td mat-cell *matCellDef="let el">
                    <span [ngClass]="el.invoiceAccepted ? 'text-success' : 'text-danger'">
                      {{ el.invoiceAccepted ? 'Accepted' : 'Rejected' }}
                    </span>
                  </td>
                </ng-container>-->
                <ng-container matColumnDef="isActive">
                  <th mat-header-cell *matHeaderCellDef>Active</th>
                  <td mat-cell *matCellDef="let el"> {{el.isActive}} </td>
                </ng-container>
                <ng-container matColumnDef="rejectedStatus">
                  <th mat-header-cell *matHeaderCellDef>Rejected Status</th>
                  <td mat-cell *matCellDef="let el"> {{el.rejectedStatus}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedInvoiceColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedInvoiceColumns;"></tr>
                Row shown when there is no matching data.
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter</td>
                </tr>
              </table>
            </div>
            <mat-paginator #paginator
                           class="demo-paginator"
                           (page)="onPageInvoiceChange($event)"
                           [length]="invoiceLength"
                           [pageSize]="invoicePageSize"
                           [showFirstLastButtons]="invoiceShowFirstLastButtons"
                           [pageSizeOptions]="invoicePageSizeOptions"
                           [hidePageSize]="invoiceHidePageSize"
                           [pageIndex]="invoicePageIndex"
                           aria-label="Select page">
            </mat-paginator>
          </div>
        </div>
        <div class="row">
          <div mat-dialog-actions class="action-buttons">
            <button mat-button mat-dialog-close (click)="onClosePopup()">Close</button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

</div>

